import axiosInstance from '../AxiosInstance';

const API_URL = '/registration/companies/apis';

class CompanyApiService {
    
    pageable(payload) {
        return axiosInstance.post('/registration/companies/superadmin/pageable', payload);
    }

    enable(companyId) {
        return axiosInstance.post(`${API_URL}/superadmin/${companyId}/enable`);
    }

    disable(companyId) {
        return axiosInstance.post(`${API_URL}/superadmin/${companyId}/disable`);
    }

    create(data) {
        return axiosInstance.post(`${API_URL}/credentials`, data);
    }

    regenerate(id) {
        return axiosInstance.post(`${API_URL}/${id}/regenerate`);
    }

    toggle(id, data) {
        return axiosInstance.patch(`${API_URL}/${id}/toggle`, data);
    }

    delete(id) {
        return axiosInstance.delete(`${API_URL}/${id}`);
    }
}

export default new CompanyApiService();
